export const ErrorScreen: React.FC = () => (
  <div style={{ padding: "80px", fontSize: "large" }}>
    Semgrep encountered an unrecoverable error. Please email support@semgrep.com
    and let us know so we can fix it!
  </div>
);
